import { FormattedMessage } from "react-intl";

import styles from "@components/PageNotFoundPage.module.css";
import AppPage from "@components/pageTypes/AppPage";
import AppPageWithMenu from "@components/pageTypes/AppPageWithMenu";
import UnauthenticatedPage from "@components/pageTypes/UnauthenticatedPage";
import ExternalLink from "@components/typography/ExternalLink";

const PageNotFound = () => (
  <UnauthenticatedPage image="activeElders">
    <div className={styles.wrapper}>
      <h1>
        <FormattedMessage id="pages.pageNotFound.title" />
      </h1>
      <p>
        <FormattedMessage id="pages.pageNotFound.explanation" />
        <ExternalLink href="mailto:support@withgrayce.com">
          <FormattedMessage id="pages.pageNotFound.contactSupport" />
        </ExternalLink>
      </p>
    </div>
  </UnauthenticatedPage>
);

type Props = {
  journeyId: string | null;
};

const PageNotFoundWithMenuPage = ({ journeyId }: Props) => (
  <>
    {journeyId ? (
      <AppPageWithMenu journeyId={journeyId}>
        <PageNotFound />
      </AppPageWithMenu>
    ) : (
      <AppPage>
        <PageNotFound />
      </AppPage>
    )}
  </>
);

export default PageNotFoundWithMenuPage;
